import { MethodCommands, MethodHandler, MethodProperties } from '@lentau/analytics/health-metrics/shared';
import {
  commentRateHandler,
  favoriteItemAddHandler,
  getCarouselHandler,
  getProductHandler,
} from './product-method-handler';
import { MethodPropertiesKey } from '../../shared/consts';

export enum ProductMethods {
  GetItemById = 'goodsItemSearchByid',
  GetCarousel = 'goodsItemCarousel',
  FavoriteItemAdd = 'favoriteItemAdd',
  CommentRate = 'commentRate',
}
export const PRODUCT_HANDLER_LIST: MethodHandler = {
  [ProductMethods.GetItemById]: getProductHandler,
  [ProductMethods.GetCarousel]: getCarouselHandler,
  [ProductMethods.FavoriteItemAdd]: favoriteItemAddHandler,
  [ProductMethods.CommentRate]: commentRateHandler,
};

export const PRODUCT_PROPERTIES_LIST: MethodProperties = new Map([
  [
    ProductMethods.GetItemById,
    [
      {
        key: MethodPropertiesKey.TEAM,
        value: MethodCommands.SE,
      },
    ],
  ],
  [
    ProductMethods.GetCarousel,
    [
      {
        key: MethodPropertiesKey.TEAM,
        value: MethodCommands.SE,
      },
    ],
  ],
  [
    ProductMethods.FavoriteItemAdd,
    [
      {
        key: MethodPropertiesKey.TEAM,
        value: MethodCommands.SE,
      },
    ],
  ],
  [
    ProductMethods.CommentRate,
    [
      {
        key: MethodPropertiesKey.TEAM,
        value: MethodCommands.SE,
      },
    ],
  ],
]);
